<div class="bar">
  <ng-content></ng-content>
</div>
<mat-divider></mat-divider>
